import React, { useState, useEffect } from "react";
import { useLoading } from "~/config/providers/LoadingProviders";
import bgContainer from '~/assets/image/bgContainer.png';
import Logo from '~/assets/image/logo.gif'; // logo image

const LoadingPage = (props) => {
    const { loading } = useLoading();

    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setAnimate(true);
        }, 500); // Tunggu 500ms sebelum animasi berjalan

        return () => clearTimeout(timer);
    }, []);

    if (!loading) return null;

    return (
        <div className="flex items-center justify-center h-screen"
            style={{
                backgroundImage: `url(${bgContainer})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }}>
            <div className="flex flex-col items-center gap-4">
                <img
                    src={Logo}
                    alt="Logo"
                    className="max-w-[80vw] max-h-[80vw] w-full h-auto"
                />
            </div>
        </div>
    );
};

export default LoadingPage;
